import React, { Component } from "react";
import Picker from "react-month-picker";

class MonthRangePicker extends Component {
  constructor(props) {
    super(props);
    let { minYear, minMonth, maxYear, maxMonth, formData } = props;
    if (formData) {
      const minDetails = formData.split(" - ")[0];
      const maxDetails = formData.split(" - ")[1];
      minYear = minDetails.split("/")[1];
      minMonth = minDetails.split("/")[0];
      maxYear = maxDetails.split("/")[1];
      maxMonth = maxDetails.split("/")[0];
    }
    this.state = {
      limit: {
        min: {
          year: minYear === undefined ? 1970 : minYear,
          month: minMonth === undefined ? 1 : minMonth,
        },
        max: {
          year: maxYear === undefined ? 2020 : maxYear,
          month: maxMonth === undefined ? 12 : maxMonth,
        },
      },
      rangeValue: {
        from: {
          year: minYear === undefined ? 2020 : minYear,
          month: minMonth === undefined ? 1 : minMonth,
        },
        to: {
          year: maxYear === undefined ? 2020 : maxYear,
          month: maxMonth === undefined ? 12 : maxMonth,
        },
      },
    };
    this.pickRange = React.createRef();
  }
  handleRangeChange = (value, text, listIndex) => {
    //
  };
  handleClickRangeBox = (e) => {
    this.pickRange.current.show();
  };
  handleRangeDissmis = (value) => {
    const { from, to } = value;
    this.props.onChange(
      ("0" + from.month).slice(-2) +
        "/" +
        from.year +
        " - " +
        ("0" + to.month).slice(-2) +
        "/" +
        to.year
    );
    this.setState({ rangeValue: value });
  };
  render() {
    const {
      schema,
      idSchema,
      required,
      readonly,
      minYear,
      minMonth,
      maxYear,
      maxMonth,
    } = this.props;
    const pickerLang = {
      months: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      from: "From",
      to: "To",
    };
    const { rangeValue } = this.state;
    const year = {
      min: {
        year: minYear === undefined ? 1970 : minYear,
        month: minMonth === undefined ? 1 : minMonth,
      },
      max: {
        year: maxYear === undefined ? 9999 : maxYear,
        month: maxMonth === undefined ? 12 : maxMonth,
      },
    };
    const makeText = (m) => {
      if (m && m.year && m.month)
        return pickerLang.months[m.month - 1] + ". " + m.year;
      return "?";
    };
    return (
      <React.Fragment>
        <label className="control-label" htmlFor={idSchema.$id}>
          {schema.title}
          {required && <span className="required">*</span>}
        </label>
        <div className="list-area">
          <ul>
            <li>
              <div className="edit">
                <Picker
                  readonly={readonly}
                  ref={this.pickRange}
                  years={year}
                  value={rangeValue}
                  lang={pickerLang}
                  theme="light"
                  onChange={this.handleRangeChange}
                  onDismiss={this.handleRangeDissmis}
                >
                  <MonthBox
                    value={
                      makeText(rangeValue.from) +
                      " - " +
                      makeText(rangeValue.to)
                    }
                    readonly={readonly}
                    onClick={this.handleClickRangeBox}
                  />
                </Picker>
              </div>
            </li>
          </ul>
        </div>
      </React.Fragment>
    );
  }
}

class MonthBox extends Component {
  constructor(props, context) {
    super(props, context);

    this.state = {
      value: this.props.value || "N/A",
    };
  }
  static getDerivedStateFromProps(props, state) {
    console.log(props, state);
    return {
      value: props.value || "N/A",
    };
  }

  render() {
    return (
      <div
        className={this.props.readonly ? "box readonly" : "box"}
        onClick={this._handleClick}
      >
        <label>{this.state.value}</label>
      </div>
    );
  }

  _handleClick = (e) => {
    this.props.onClick && this.props.onClick(e);
  };
}
export default MonthRangePicker;
